<template>
  <div>

    <Head />
    <div class="layout">
      <div class="platform">
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p class="tit">区块链分级诊疗平台</p>
              <p class="text">基于区块链技术建立“基层首诊、双向转诊、急慢分治、上下联动”的就医生态，促进优质医疗资源纵向流动，合理引导病人就医流向</p>
            </div>
            <div class="right">
              <img
                src="../../../assets/images/pc/solution/part1-2.png"
                alt
              />
            </div>
          </div>
        </div>
        <div class="part-2">
          <div class="main">
            <p class="tit">方案介绍</p>
            <div class="content">
              <div class="line">
                为缓解患者网络预约困难、号源变动同步不及时等现状，区块链分级诊疗平台利用恒为链的可信号源记录和安全共享服务，解决患者挂号难、就医不便等问题。
              </div>
              <div class="line">
                区块链分级诊疗平台通过恒为链建立可信号源记录和安全共享服务，提升患者就医体验，缓解网络取号难的现状。同时，通过恒为链实时同步号源的服务，保障号源的唯一有效性，杜绝无效号源；基于恒为链数据的防篡改服务，确保预约服务的真实性。在便民服务的基础上充分利用可信防篡改区块链数据，精准统计各类门诊号源总量，预约率、履约率、渠道履约率、社区下沉率等指标，为医疗管理决策提供有效的数据支撑。
              </div>
              <div class="img">
                <img
                  src="../../../assets/images/pc/solution/classification/part2.png"
                  alt=""
                >
              </div>
            </div>
          </div>
        </div>
        <div class="part-3">
          <div class="main">
            <p class="tit">方案价值</p>
            <div class="content">
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/classification/part3-1.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">医院受益</p>
                  <p class="txt">优化门诊患者结构，提升医疗资源利用率，实现患者就医的有序管理和服务</p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/classification/part3-2.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">患者受益</p>
                  <p class="txt">优化便民惠民服务，增强居民就医便利性</p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/classification/part3-3.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">政府受益</p>
                  <p class="txt">加强区域就医秩序管理，提升科学制定区域医疗政策的能力</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="part-4">
          <div class="main">
            <p class="tit">应用案例</p>
            <div class="content">
              <swiper
                ref="mySwiper"
                :options="swiperOptions"
              >
                <swiper-slide>
                  <div class="card2">
                    <div class="title">
                      江苏预约诊疗服务系统
                    </div>
                    <div class="txt bottom">
                      基于恒为链的江苏预约诊疗服务系统，为患者提供精准就医服务。通过恒为链与网上就医预约的融合，实现号源和号源使用记录的可信采集、全程上链及动态管理。江苏预约诊疗服务系统将采集到的就医信息向各级各类预约挂号应用安全、平等、透明的共享，进一步完善便民服务的预约范围。同时，系统利用恒为链上链数据真实有效、可追溯等特性，形成可信“信息链条”，促成医患之间、医疗机构之间的相互信任关系，实现身份互认，并打通相关凭证、资质和授权信息的共用同享。
                    </div>
                    <div class="txt">
                      系统旨在实现号源的信息可信、公开，预约服务的公平、透明，患者体验的一致、便捷，数据管理的多维、精确，真正做到就医的利民、便民。
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
              <div
                class="swiper-pagination"
                slot="pagination"
              ></div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/pc/Head";
import Foot from "../../../components/pc/Foot";
import api from "../../../common/api";
import { Button } from "iview";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "service",
  components: {
    Head,
    Foot,
    Button,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      cn: false,
      en: false,
      swiperOptions: {
        //swiper配置
        //autoplay: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //分页控制切换
        },
        // Some Swiper option/callback...
      },
    };
  },
  mounted() {
    this.mobile();
  },
  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      if (localStorage.Lang == "en") {
        this.en = true;
      } else {
        this.cn = true;
      }
    },
    mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if ((flag && flag.length) > 0) {
        this.$router.replace("/mobile" + this.$route.path);
      }
    },
  },
};
</script>
<style  lang="less"  scoped>
@import url("../../../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  // max-width:@max-width;
  min-width: @min-width;
  background-color: #f8f9fb;
}
.platform {
  .part-1 {
    width: 100%;
    .p1();
    background: linear-gradient(-30deg, #1460b6, #2b9ce4);
    .main {
      .clearfix();
    }
    .left {
      width: 54%;
      float: left;
      .tit {
        .hTit();
        margin: 185px 0 25px 0;
      }
      .text {
        width: 510px;
        .hText();
      }
    }
    .right {
      width: 46%;
      float: left;
      img {
        margin: 63px 0 0 75px;
        width: 386px;
        height: 400px;
      }
    }
  }
  .part-2 {
    background: #fff;
    padding: 80px 0 80px;
    .main {
      .clearfix();
      height: 100%;
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        width: 100%;
        height: 100%;
        .line {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 15px;
        }
        .img {
          margin-top: 35px;
          text-align: center;
          img {
            width: 817px;
            height: auto;
          }
        }
      }
    }
  }

  .part-3 {
    padding: 80px 0 80px;
    background: #f9f9f9;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        width: 100%;
        .card {
          width: 1140px;
          height: 184px;
          display: flex;
          padding: 38px 20px;
          background: #ffffff;
          margin: 15px auto;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          .left {
            width: 179px;
            img {
              height: 100%;
              height: 108px;
            }
          }
          .right {
            padding: 25px 0 0 20px;

            .title {
              color: #444444;
              font-size: 20px;
              text-align: left;
              margin-bottom: 4px;
            }
            .txt {
              color: #888888;
              text-align: left;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .part-4 {
    padding: 80px 0 80px;
    background: #ffffff;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        display: flex;
        flex-wrap: wrap;
        .card {
          height: 332px;
          background: #fff;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          margin: 10px;
          padding: 10px;
          display: flex;
          .left {
            width: 447px;
            img {
              height: 100%;
              width: 100%;
            }
          }
          .right {
            flex: 1;
            padding: 15px 42px 0 59px;
            .l1 {
              color: #444444;
              font-size: 20px;
            }
            .l2 {
              margin: 10px 0 0;
              color: #888888;
              font-size: 14px;
              line-height: 24px;
            }
            .l3 {
              color: #888888;
              font-size: 14px;
              height: 32px;
              span {
                display: inline-block;
                height: 32px;
                line-height: 32px;
              }
              img {
                vertical-align: top;
                width: 32px;
                height: 32px;
              }
              .s3 {
                margin-left: 30px;
              }
            }
          }
        }
        .card2 {
          height: 332px;
          background: #fff;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          margin: 10px;
          padding: 60px 55px 0 51px;
          .title {
            font-size: 20px;
            color: #444444;
            line-height: 20px;
            text-align: center;
            margin-bottom: 35px;
          }
          .bottom {
            margin-bottom: 10px;
          }

          .txt {
            font-size: 14px;
            color: #888888;
            line-height: 24px;
          }
        }
        .swiper-pagination {
          position: static; //取消定位
          display: block;
          margin: 30px auto 0;
          /deep/.swiper-pagination-bullet {
            background: #d4d4d4;
            margin: 0 5px;
            opacity: 1;
            outline: none; //清除点击突出的边框
          }
          /deep/.swiper-pagination-bullet-active {
            background: #2a93ff;
            position: relative;
            top: -2px;
            width: 28px;
            height: 4px;
            border-radius: 5px;
            opacity: 1;
            outline: none;
          }
        }
      }
    }
  }
}
</style>